export default "__VITE_ASSET__DvNcSYQ0__"